import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { ScoreCell } from '../../../RecordingsList/cells/ScoreCell';
import { scoreLabel } from '../../../RecordingsList/utils/getScoreLabel';
import { getEngagementScoreAsBucket } from '../../../RecordingsList/utils/calculateScore';
import { Cell } from './RecordingOverviewWidgetCell';

import type { RecordingOverviewWidgetCellParams } from './RecordingOverviewWidgetCell';

export const RecordingOverviewWidgetCellEngagementScore = ({
  recording,
}: RecordingOverviewWidgetCellParams): JSX.Element | null => {
  const { t } = useTranslation();

  if (!recording) return null;

  const score = getEngagementScoreAsBucket(recording?.relevanceScore);
  return (
    <Cell>
      {score ? (
        <ScoreCell
          score={score}
          colorActive={tokens.BRAND_COLORS.cobalt_900}
          colorInactive={tokens.BRAND_COLORS.cobalt_400}
          trackingLabel="Engagement"
          title={t(`common:recordings.engagement-score.${scoreLabel[score]}.title`)}
          text={t(`common:recordings.engagement-score.${scoreLabel[score]}.text`)}
          trigger="mouseenter focus"
        />
      ) : null}
    </Cell>
  );
};
